export const formatOptionalText = (value: string | null): string => {
  if (!value) return '—';
  return value;
};
